import _isNumber from 'lodash/isNumber';
var MAX_CURRENCY_PRECISION = 2;
export function isMoneyString(price) {
  if (_isNumber(price)) {
    return false;
  }
  var moneyRegex = /^[+-]?\d+\.(\d\d)$/;
  return moneyRegex.test(price) && !Number.isNaN(+price);
}
export function isPriceLabel(price) {
  if (_isNumber(price)) {
    return false;
  }
  return !isMoneyString(price);
}
function formatAmount(amount, precision) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: precision
  }).format(amount);
}
function isWholeAmountByPrecision(amount, precision) {
  return Math.pow(10, precision) * amount % 1 === 0;
}
export function formatCurrency(amount) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_CURRENCY_PRECISION;
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$hideCurrencySign = _ref.hideCurrencySign,
    hideCurrencySign = _ref$hideCurrencySign === void 0 ? false : _ref$hideCurrencySign;
  var price = '';
  if (precision <= 1 && isWholeAmountByPrecision(amount, 0)) {
    price = "$".concat(Math.trunc(amount));
  } else if (precision <= 1 && isWholeAmountByPrecision(amount, 1)) {
    price = "$".concat(+amount.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '&,'));
  } else {
    price = formatAmount(+amount, MAX_CURRENCY_PRECISION);
  }
  return hideCurrencySign ? price.replace('$', '') : price;
}